import React from 'react';
import { Button, ModalHeader, Modal, ModalBody, ModalFooter, UncontrolledTooltip, Input } from 'reactstrap';
import { Link } from 'react-router-dom'
import { sortableHandle } from 'react-sortable-hoc';
import DeleteButton from '../AuthorUIComponents/DeleteButton'
import { connect } from 'react-redux'
import { courses } from '../../../../redux/actions/courses'
import { PulseLoader } from 'react-spinners';

const DragHandle = sortableHandle(() => <span className="drag-handle"></span>);

class LessonCollapsable extends React.Component {
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
        this.state = { collapse: false, addLesson: false, showModal: false, showMoveModal: false, currentOrder: undefined, name: '' };
    }

    toggle() {
        this.setState(state => ({ collapse: !state.collapse }));
    }

    toggleAdd() {
        this.setState(state => ({ addLesson: !state.addLesson }))
    }
    showMoveModal = () => {
        this.setState(state => ({ showMoveModal: !state.showMoveModal }))
    }

    showDeleteModal = () => {
        this.setState(state => ({ showDeleteModal: !state.showDeleteModal }))
    }

    componentDidMount() {
        this.setState((state, props) => ({ currentOrder: Number(props.value.index) }));
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.toggleCard) {
            this.props.toggle !== prevProps.toggle && this.setState({ collapse: false })
        }
        if ((this.props.reArrange !== prevProps.reArrange)) {
            this.props.onSortEnd({ oldIndex: this.props.index, newIndex: Number(this.state.currentOrder) - 1 })
        }

        if (prevProps.courses.deletingLesson && !this.props.courses.deletingLesson) {
            this.setState({ showModal: false })
        }



        if ((this.state.currentOrder !== this.props.value.index)) {
            this.props.updateLessonIndex(this.props.value.id, Number(this.props.index) + 1)
        }
    }

    handleIndexChange = () => {
        (this.props.value.index !== this.state.currentOrder) && this.props.updateIndexLesson(this.props.value.sectionId, [{ index : this.state.currentOrder , id: this.props.value.id}])
    }

    submit = () => {
        const { section } = this.props;
        let lesson = {
            name: this.state.name,
            displayName: this.state.name
        }
        this.props.createLesson(lesson, section)
    }

    handleChange = e => {
        this.setState({ name: e.target.value })
    }


    deleteLesson = () => { this.props.deleteLesson(this.props.value.id, this.props.value.sectionId) }

    handleRightColums = (type, value) => {
        let rightColumToggles = {
            addItemMenu: false,
            previewItem: false,
            simulateItem: false
        }

        delete rightColumToggles[type]

        this.setState({
            [type]: true,
            singleItem: value ? value : null,
            ...rightColumToggles
        })
    }


    showModal = (lesson, action) => {
        let modalText = "";
        let desc = "";
        let modalAction;
        if (action === "delete") {
            modalText = `Attempting to delete ${lesson.name} (${lesson.displayName}). Are you sure you want to delete this lesson? This action cannot be reversed. All lesson data will be lost.`;
            desc = "Delete";
            modalAction = this.deleteLesson;
        }
        this.setState({
            showModal: true,
            modalText,
            desc,
            modalAction
        });
    }

    getModal = () => {
        return (
            <Modal isOpen={this.state.showModal} className={"modal-success"}>
                <ModalHeader>{this.state.desc} Lesson</ModalHeader>
                <ModalBody>{this.state.modalText}</ModalBody>
                <ModalFooter>
                    <Button onClick={() => this.state.modalAction()} color="secondary">
                        {(this.props.courses.deletingLesson)
                            ? <div className="m-auto text-center"><PulseLoader loading color={'#4c6572'} /></div>
                            : this.state.desc
                        }
                    </Button>
                    <Button
                        onClick={() => this.setState({ showModal: false })}
                        color="secondary"
                    >
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
        );
    }


    handleOrderChange = (e) => {
        this.setState({ currentOrder: e.target.value })
    }

    render = () => {
        const { index, lastItem, onSortEnd, value, addLesson, reArrange, courses } = this.props
        const { currentOrder, name } = this.state;
        return (
            <React.Fragment><tr className="edit-subcourse-row">
                {reArrange && <td><DragHandle /></td>}
                <td>{reArrange ? <Input onBlur={() => this.handleIndexChange()} className="lesson-text-box" onChange={this.handleOrderChange} value={Number(currentOrder)} /> : <span>{currentOrder}</span>}</td>
                {reArrange && <td><span className="lesson-arrange-arrows">{(index > 0) && <span onClick={() => onSortEnd({ oldIndex: index, newIndex: Number(index) - 1 })} className="lesson-arrange-arrow-up"></span>}{(Number(index) !== Number(lastItem) - 1) && <span onClick={() => onSortEnd({ oldIndex: index, newIndex: Number(index) + 1 })} className="lesson-arrange-arrow-down"></span>}</span></td>}
                {reArrange && <td><DeleteButton index={index} handleDelete={() => this.showModal(value, "delete")} /></td>}
                {reArrange && <td><Link to={`/author/lesson/${value.id}`}><i style={{ height: '20px', width: '20px' }} class="edit-icon"></i></Link></td>}
                <td>{value.name}</td>
                <td>{value.interactionBank ? value.interactionBank : 0}</td>
                <td>{value.itemBank ? value.itemBank : 0}</td>
                <td>{value.rules ? value.rules : 0}</td>
                {/* <td><i style={{width : '20px', height : '20px'}} onClick={this.showDeleteModal} className="delete-icon" /></td> */}
            </tr>
                {((Number(lastItem) - 1) === index) && addLesson && <tr className="new-item-section scroll-to-lesson">
                    <td colSpan={reArrange ? 5 : 1}></td>
                    <td className="p-2 subcourse-head">Add new Lesson</td>
                    <td colSpan="2" sm="9"><Input onChange={this.handleChange} value={name} placeholder={'Enter Lesson Name ..'} /></td>
                    <td colSpan="1" sm="3" className="pl-0">
                        <Button className="w-100" disabled={this.state.name === ''} onClick={this.submit}>{courses.creatingLesson ? <div className="m-auto"><PulseLoader loading color={'#fff'} size={10} /></div> : 'Save'}</Button>
                    </td>
                </tr>}
                {!reArrange &&
                <div id={`row-side-menu-${index}`} className='row-side-menu'>
                    <Button onClick={() => this.handleRightColums('simulateItem', value)} className='icon-btn'><i className='screen-eye-icon'></i></Button>
                    <Button onClick={() => this.handleRightColums('previewItem', value)} className='icon-btn'><i className='preview-icon'></i></Button>
                </div>}
                {this.getModal()}
            </React.Fragment>
        );
    }
}



const mapStateToProps = state => {
    return {
        courses: state.courses
    }
}

const mapDispatchToProps = dispatch => {
    return {
        //   updateIndexSubCourse: (courseId, indexes) => { dispatch(courses.updateIndexSubCourse(courseId, indexes)) },
        //   toggleSubcourseStatus: (subcourseId, status) => { dispatch(courses.toggleSubcourseStatus(subcourseId, status)) },
        createLesson: (lesson, section) => { dispatch(courses.createLesson(lesson, section)) },
        getSection: (subcourseId) => { dispatch(courses.getSection(subcourseId)) },
        deleteLesson: (lessonId, sectionId) => { dispatch(courses.deleteLesson(lessonId, sectionId)) },
        updateIndexLesson: (sectionId, indexes) => { dispatch(courses.updateIndexLesson(sectionId, indexes)) },

    }
}


export default connect(mapStateToProps, mapDispatchToProps)(LessonCollapsable)


// WEBPACK FOOTER //
// ./src/components/Users/Authors/AuthorCollapsable/LessonCollapsable.js